// Kredi Ekle sihirbazı kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.addLoan';

export const addLoanGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Kredi nasıl eklenir?'),
  intro: t(`${G}.intro`, 'Kredi üç adımda eklenir: Kredi Bilgileri, Taksit Planı ve Aktarım & Özet. Bir adımdaki zorunlu bilgiler doğru olmadan "İleri" düğmesi açılmaz; "Geri" ile önceki adıma dönebilirsiniz.'),
  navItems: [
    t(`${G}.nav.details`, 'Kredi Bilgileri'),
    t(`${G}.nav.plan`, 'Taksit Planı'),
    t(`${G}.nav.transfer`, 'Aktarım & Özet'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    tabs: t(`${G}.regions.tabs`, 'Adımlar'),
    body: t(`${G}.regions.body`, 'Adım içeriği'),
    footer: t(`${G}.regions.footer`, 'Geri / İleri / Kaydet'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Kredi bilgilerini girin'),
      text: t(`${G}.s1.text`, 'Kredinin Çekildiği Banka, Kredi Adı, Kullanım Tarihi, Anapara ve Toplam Geri Ödeme zorunludur. Kredinin para birimi seçtiğiniz banka hesabının para birimidir. Kredi/Sözleşme No isteğe bağlıdır.'),
      tips: [
        t(`${G}.s1.tip1`, 'Tutarları 200.000 veya 200.000,50 biçiminde yazın; nokta kendiliğinden eklenir.'),
        t(`${G}.s1.tip2`, 'Toplam Geri Ödeme anaparadan küçük olamaz. Aradaki fark "Toplam Faiz" olarak gösterilir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Kesintileri ekleyin'),
      text: t(`${G}.s2.text`, 'Bankanın krediden düştüğü masrafları Kesintiler bölümüne ekleyin: Dosya Masrafı, Hayat Sigortası, BSMV, KKDF, Damga Vergisi, Ekspertiz hazır düğmelerle eklenir; "+ Kesinti Ekle" ile kendi kesintinizi yazın.'),
      tips: [
        t(`${G}.s2.tip1`, 'Hesaba Geçecek Net Tutar = Anapara − Kesinti Toplamı.'),
        t(`${G}.s2.tip2`, 'Kesinti toplamı anaparadan küçük olmalı; her kesintinin adı dolu olmalıdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Taksit planını oluşturun'),
      text: t(`${G}.s3.text`, 'Taksit Sayısı (1–360), İlk Vade Tarihi ve Periyot (Aylık, Haftalık, 3 Aylık) seçip "Planı Oluştur"a basın. Toplam geri ödeme eşit taksitlere bölünür; kuruş farkı son taksite eklenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Her taksidin vadesini ve tutarını tabloda değiştirebilir, satır silebilir veya "Taksit Ekle" ile satır ekleyebilirsiniz.'),
        t(`${G}.s3.tip2`, '"Anapara/Faiz Kırılımı" ile her taksidin anapara ve faiz payını isteğe bağlı girebilirsiniz.'),
        t(`${G}.s3.tip3`, 'İlerlemek için taksit toplamı Toplam Geri Ödeme ile tutmalı ve vadeler artan sırada olmalıdır; alttaki kutu yeşil olunca hazırdır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Net tutarın aktarımını seçin'),
      text: t(`${G}.s4.text`, 'Aktarım & Özet adımında net tutarın nereye gireceğini seçin. Listede yalnız kredi ile aynı para birimindeki hesaplar çıkar.'),
      tips: [
        t(`${G}.s4.tip1`, 'Aktarma: para hareketi oluşmaz; kredi yalnız kayda geçer.'),
        t(`${G}.s4.tip2`, 'Banka hesabına aktar / Kasaya aktar: net tutar, kullanım tarihiyle seçilen banka hesabına veya kasaya giriş olarak eklenir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Özeti kontrol edip kaydedin'),
      text: t(`${G}.s5.text`, 'Özet kutusunda anapara, toplam geri ödeme, faiz, kesintiler, net kullandırım, taksit sayısı ve ilk / son vade görünür. Doğruysa "Kaydet"e basın; kredi "Aktif" olarak Krediler listesine eklenir. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
